(() => {
  const dismissedOffers = new Set();
  let lastComplementSignature = '';
  let currentComplementKeys = [];
  let cartNoteValue = '';
  let cartNoteInitialized = false;
  let cartScrollTop = 0;
  let restoreScrollUntil = 0;
  let cartScrollRestorePending = false;
  let initTimers = [];
  let reopenCartUntil = 0;
  let cartNoteOpen = false;
  let cartNoteOpenInitialized = false;
  let pouchDiscountPendingVariant = '';

  function openNextOffer(root) {
    const next = [...root.querySelectorAll('[data-ss-offer-modal][hidden]')]
      .find((modal) => !dismissedOffers.has(modal.dataset.ssOfferModal));

    if (!next) {
      root.closest('cart-drawer')?.classList.remove('ss-offer-open');
      return;
    }
    next.hidden = false;
    root.closest('cart-drawer')?.classList.add('ss-offer-open');
    next.querySelector('.ss-cart-offer-modal__close')?.focus();
  }

  function bindOffers(root) {
    if (root.dataset.ssOffersBound === 'true') return;
    root.dataset.ssOffersBound = 'true';

    root.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-ss-offer-open]');
      if (opener) {
        const modal = root.querySelector(`[data-ss-offer-modal="${CSS.escape(opener.dataset.ssOfferOpen)}"]`);
        if (!modal) return;
        opener.setAttribute('aria-expanded', 'true');
        modal.hidden = false;
        root.closest('cart-drawer')?.classList.add('ss-offer-open');
        modal.querySelector('.ss-cart-offer-modal__close')?.focus();
        return;
      }

      const close = event.target.closest('[data-ss-offer-close]');
      if (!close) return;

      const modal = close.closest('[data-ss-offer-modal]');
      dismissedOffers.add(modal.dataset.ssOfferModal);
      modal.hidden = true;
      root.closest('cart-drawer')?.classList.remove('ss-offer-open');
      const restoreOpener = root.closest('cart-drawer')?.querySelector(`[data-ss-offer-open="${CSS.escape(modal.dataset.ssOfferModal)}"]`);
      restoreOpener?.setAttribute('aria-expanded', 'false');
      restoreOpener?.focus();
    });

    // Keep the cart usable after AJAX updates. Offer dialogs remain hidden
    // until a future explicit customer action opens them.
    root.closest('cart-drawer')?.classList.remove('ss-offer-open');
  }

  function complementKey(card) {
    return card.querySelector('a')?.href || card.querySelector('input[name="id"]')?.value || '';
  }

  function shuffleComplements(rail, forceNew = false) {
    const cards = [...rail.querySelectorAll('.ss-cart-complement-card')];
    if (cards.length < 2) return;

    let selected = [];
    if (!forceNew && currentComplementKeys.length) {
      selected = currentComplementKeys
        .map((key) => cards.find((card) => complementKey(card) === key))
        .filter(Boolean);
    }

    if (selected.length === Math.min(5, cards.length)) {
      cards.forEach((card) => { card.hidden = true; });
      selected.forEach((card) => {
        card.hidden = false;
        rail.appendChild(card);
      });
      rail.scrollTo({ left: 0, behavior: 'auto' });
      return;
    }

    for (let index = cards.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [cards[index], cards[randomIndex]] = [cards[randomIndex], cards[index]];
    }

    selected = cards.slice(0, Math.min(5, cards.length));
    let signature = selected.map(complementKey).join('|');
    if (signature === lastComplementSignature && cards.length > selected.length) {
      cards.push(cards.shift());
      selected = cards.slice(0, Math.min(5, cards.length));
      signature = selected.map(complementKey).join('|');
    }

    cards.forEach((card) => { card.hidden = true; });
    selected.forEach((card) => {
      card.hidden = false;
      rail.appendChild(card);
    });
    rail.scrollTo({ left: 0, behavior: 'auto' });
    currentComplementKeys = selected.map(complementKey);
    lastComplementSignature = signature;
  }

  function initComplements(rail) {
    if (!rail || rail.dataset.ssRotationBound === 'true') return;
    rail.dataset.ssRotationBound = 'true';
    shuffleComplements(rail);
  }

  function restoreCartState() {
    const drawer = document.querySelector('cart-drawer');
    const note = document.getElementById('CartDrawer-Note');
    const noteDetails = document.querySelector('[data-ss-order-note]');
    const items = document.querySelector('cart-drawer-items');

    if (drawer && Date.now() < reopenCartUntil) drawer.open();
    restoreCartScroll(items);
    if (note) {
      if (!cartNoteInitialized) {
        cartNoteValue = note.value;
        cartNoteInitialized = true;
      } else if (note.value !== cartNoteValue) {
        note.value = cartNoteValue;
      }
    }
    if (noteDetails) {
      if (!cartNoteOpenInitialized) {
        cartNoteOpen = noteDetails.open;
        cartNoteOpenInitialized = true;
      } else {
        noteDetails.open = cartNoteOpen;
      }
    }
  }

  function initOrderNote(details) {
    if (!details || details.dataset.ssOrderNoteBound === 'true') return;
    details.dataset.ssOrderNoteBound = 'true';

    details.addEventListener('toggle', () => {
      cartNoteOpen = details.open;
      cartNoteOpenInitialized = true;

      if (!details.open) return;
      requestAnimationFrame(() => {
        const items = details.closest('cart-drawer-items');
        items?.scrollTo({ top: items.scrollHeight, behavior: 'smooth' });
      });
    });
  }

  function restoreCartScroll(items = document.querySelector('cart-drawer-items')) {
    if (!cartScrollRestorePending || !items || Date.now() >= restoreScrollUntil) return;

    const maxScroll = Math.max(0, items.scrollHeight - items.clientHeight);
    items.scrollLeft = 0;
    items.scrollTop = Math.min(cartScrollTop, maxScroll);
  }

  function rememberCartViewport() {
    const note = document.getElementById('CartDrawer-Note');
    const items = document.querySelector('cart-drawer-items');

    if (note) {
      cartNoteValue = note.value;
      cartNoteInitialized = true;
    }
    if (!items) return;

    cartScrollTop = items.scrollTop;
    cartScrollRestorePending = true;
    restoreScrollUntil = Date.now() + 4000;
  }

  function restoreCartScrollAfterUpdate() {
    if (!cartScrollRestorePending || Date.now() >= restoreScrollUntil) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        restoreCartScroll();
        cartScrollRestorePending = false;
      });
    });
  }

  function reopenCartAfterUpdate() {
    if (Date.now() >= reopenCartUntil) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        document.querySelector('cart-drawer')?.open();
      });
    });
  }

  function initCartExtras() {
    document.querySelectorAll('[data-ss-cart-offer-modals]').forEach(bindOffers);
    document.querySelectorAll('[data-ss-complements]').forEach(initComplements);
    document.querySelectorAll('[data-ss-order-note]').forEach(initOrderNote);
    restoreCartState();
  }

  function scheduleCartExtras() {
    initTimers.forEach(clearTimeout);
    initTimers = [200, 600, 1200, 2200].map((delay) => setTimeout(initCartExtras, delay));
  }

  function rememberCartNote(event) {
    if (event.target.id !== 'CartDrawer-Note') return;
    cartNoteValue = event.target.value;
    cartNoteInitialized = true;
  }

  document.addEventListener('DOMContentLoaded', initCartExtras);
  document.addEventListener('input', rememberCartNote);
  document.addEventListener('change', rememberCartNote);
  document.addEventListener('focusout', rememberCartNote);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (pouchDiscountPendingVariant && String(event?.productVariantId) === pouchDiscountPendingVariant) {
        pouchDiscountPendingVariant = '';
        window.location.assign('/discount/POUCH25-UPSELL?redirect=/cart');
        return;
      }
      reopenCartAfterUpdate();
      restoreCartScrollAfterUpdate();
      scheduleCartExtras();
    });
  }
  document.addEventListener('submit', (event) => {
    const isPouchOffer = event.target.matches('[data-ss-pouch-offer-form]');
    if (isPouchOffer) {
      pouchDiscountPendingVariant = event.target.querySelector('[name="id"]')?.value || '';
    }
    if (!event.target.matches('.ss-cart-complement-card form, [data-ss-pouch-offer-form]')) return;
    rememberCartViewport();
    reopenCartUntil = Date.now() + 4000;
    scheduleCartExtras();
  }, true);
  document.addEventListener('click', (event) => {
    const offerOpener = event.target.closest('[data-ss-offer-open]');
    if (offerOpener) {
      const drawer = offerOpener.closest('cart-drawer');
      const root = drawer?.querySelector('[data-ss-cart-offer-modals]');
      const modal = root?.querySelector(`[data-ss-offer-modal="${CSS.escape(offerOpener.dataset.ssOfferOpen)}"]`);
      if (!modal) return;

      offerOpener.setAttribute('aria-expanded', 'true');
      modal.hidden = false;
      drawer.classList.add('ss-offer-open');
      modal.querySelector('.ss-cart-offer-modal__close')?.focus();
      return;
    }

    if (event.target.closest('.ss-cart-complement-card button[name="add"]')) {
      rememberCartViewport();
      reopenCartUntil = Date.now() + 4000;
      scheduleCartExtras();
    }
    if (event.target.closest('quantity-input button, cart-remove-button button')) {
      rememberCartViewport();
      scheduleCartExtras();
    }
    if (event.target.closest('#cart-icon-bubble')) {
      requestAnimationFrame(() => {
        document.querySelectorAll('[data-ss-complements]').forEach((rail) => shuffleComplements(rail, true));
      });
    }
  }, true);
})();
